import React, { createContext, FC, useContext } from 'react';
import { Node } from '@glueapp/graph-types';

export const CurrentNodeContext = createContext<Node | null>(null);

interface CurrentNodeContextProviderProps {
    node: Node;
    children: React.ReactNode;
}

export const CurrentNodeContextProvider: FC<CurrentNodeContextProviderProps> = props => {
    return <CurrentNodeContext.Provider value={props.node}>{props.children}</CurrentNodeContext.Provider>;
};

export function useCurrentNode(): Node {
    const node = useContext(CurrentNodeContext);
    if (!node) {
        throw new Error('useCurrentNode must be used within a CurrentNodeContextProvider');
    }
    return node;
}
